import ActiveRecordResource from '../ActiveRecordResource';
import config from 'config';
import { UserDTO } from '../manager';

import { ImageDTO, Image } from "./../image";

export interface FanFeedPostDTO {
  id?: string;
  created_by: UserDTO;
  created_at: number;
  publish_at?: number;
  liked_by_user: boolean;
  user_owns: boolean;
  image_urls: ImageDTO
  likes_count: number
  tags: string[]
  video_url: string
  status: string
  text: string
}

export default class FanFeedPost extends ActiveRecordResource {
  static path = `${config.backOfficeBasePath}/fan_feed/posts`;

  static mapRecords(data) {
    return data.map((item) => this.parseData(item));
  }

  static parseData(data: FanFeedPostDTO): FanFeedPost {
    let res = new FanFeedPost({});

    return Object.assign(res, res._parseData(data));
  }

  liked_by_user: boolean = false;
  user_owns: boolean;
  likes_count: number
  createDate: Date;
  publishDate: Date;
  image: Image;
  tags: string[] = []
  video_url: string
  status: string
  text: string

  _getModel() {
    return FanFeedPost;
  }

  // get isPublished() {
  //   return this.published;
  // }

  _parseData(data: FanFeedPostDTO) {
    let res: any = {
      id: data.id,
      image: data.image_urls ? new Image(Object.assign(new ImageDTO(), data.image_urls)) : null,
      liked_by_user: data.liked_by_user,
      user_owns: data.user_owns,
      likes_count: data.likes_count,
      tags: data.tags,
      video_url: data.video_url,
      createdBy: data.created_by,
      status: data.status,
      text: data.text,
      createDate: new Date(data.created_at),
      publishDate: data.publish_at ? new Date(data.publish_at) : null,
    };

    return res;
  }
  
  async accept(): Promise<FanFeedPost> {
    return await this.patch(true)
  }
  
  async reject(rejection_reason: string): Promise<FanFeedPost> {
    return await this.patch(false, rejection_reason)
  }

  async patch(accept: boolean, rejection_reason?: string): Promise<FanFeedPost> {
    await this._networkLayer.postJson(this._prepareUrl(this.id) + '/actions', { status: (accept ? 'accepted' : 'rejected'), rejection_reason });
    this._extendData({ status: accept ? 'accepted' : 'rejected'});
    return this;
  }

}



// WEBPACK FOOTER //
// ./src/api/fan_feed/fan_feed_posts.ts